import { createQueryKeys, type inferQueryKeys } from '@lukemorales/query-key-factory';
import { getViewupAccounts } from 'app/_entities/sns-account';
import { getViewingTypeInfo } from './mapper/getViewingTypeInfo';

export const viewingCommonQueryKey = createQueryKeys('viewingCommon', {
  accounts: {
    queryFn: async () => {
      const data = await getViewupAccounts();
      return data;
    },
    queryKey: null,
  },
  all: null,
  rewards: {
    queryFn: async () => {
      const data = await getViewingTypeInfo();
      return data;
    },
    queryKey: null,
  },
});

export type ViewingCommonQueryKey = inferQueryKeys<typeof viewingCommonQueryKey>;
